// window.bsn = require('bootstrap.native/dist/bootstrap-native-v4');
require('./helpers');
require('./clickout');
require('simplebar');
import { tns } from 'tiny-slider/src/tiny-slider'
window.tns = tns
import navbar from './navbar'
import ClipPath from '../../libs/clipPathCustom/index'
import sliderOneImage from './slider-one-image'
import types from './types'
import tissue from './tissue'
import gallery from './gallery'
import productTypes from './product-types'
import sliders from './sliders'
import callbackForm from './callback-form'
import photoLink from './photo-link'
// import phoneMask from './phone-mask'


navbar()
types()
ClipPath('[data-clip]')
tissue()
gallery()
productTypes()
sliders()
sliderOneImage()
callbackForm()

photoLink(document.querySelectorAll('.js-photo-link'))
document.querySelectorAll('.js-product-type-slide').forEach(function (value) {
  photoLink(value.querySelectorAll('.js-photo-product'))
})
document.querySelectorAll('.js-photo-link--one').forEach(function (value) {
  photoLink([value])
})
// phoneMask()

require('./jivosite');

if(window.lazyLoadInstance){
  window.lazyLoadInstance.update()
}
document.body.classList.add('page-loaded')
